import { Mailbox } from 'react-bootstrap-icons';

import { Button, List, message, Typography } from 'antd';

import EmptyState from '@/components/shared/EmptyState';
import { useGetUnsubscribedProducersQuery, useSubscribeToProducerMutation } from '@/services/notifications';
import styled, { css, StyledProp } from '@/styled';

const UnsubscribeList = (props: StyledProp) => {
  const list = useGetUnsubscribedProducersQuery();
  const [subscribe, { isLoading, originalArgs }] = useSubscribeToProducerMutation();

  const subscribeToProducer = (producerId: number) => () => {
    subscribe(producerId)
      .then(() => message.success('Inscrição feita com sucesso!'))
      .catch(() => message.error('Não foi possível fazer inscrição no momento!'));
  };

  return (
    <div className={props.className}>
      <Typography.Title level={4}>Notificações desabilitadas via e-mail</Typography.Title>
      <Typography.Paragraph className='subtitle'>
        Habilite abaixo para voltar a receber as notificações via e-mail
      </Typography.Paragraph>
      <List
        renderItem={producer => (
          <div className='item'>
            <Typography.Paragraph strong>{producer.name}</Typography.Paragraph>
            <Button
              type='primary'
              onClick={subscribeToProducer(producer.id)}
              disabled={originalArgs !== producer.id && isLoading}
              loading={originalArgs === producer.id && isLoading}
            >
              Habilitar notificação
            </Button>
          </div>
        )}
        dataSource={list.data}
        locale={{
          emptyText: (
            <EmptyState
              className='emptyState'
              icon={<Mailbox />}
              title='Todas as notificações estão habilitadas.'
              description=''
            />
          )
        }}
      />
    </div>
  );
};

export default styled(UnsubscribeList)(
  ({ theme }) => css`
    .ant-list-empty-text {
      padding: 0;
    }

    .emptyState {
      padding: 0;
      padding-top: ${theme.space.pxToRem(28)};
      border: 1px solid ${theme.variables.borderColor};
      border-radius: ${theme.borderRadius}px;

      .ant-typography {
        color: ${theme.colorTextTertiary};
      }

      svg {
        fill: ${theme.colorTextTertiary};
      }
    }

    .item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: ${theme.space.spacing(4, 7)};
      border-bottom: 1px solid ${theme.palette.alpha(theme.palette.gray[0], 0.45)};

      &:last-child {
        border-width: 0;
      }

      button {
        background: ${theme.palette.alpha(theme.palette.gray[0], 0.08)};
        color: ${theme.palette.gray[0]};
        height: 36px;
        width: 177px;
        &:hover {
          background: ${theme.palette.alpha(theme.palette.gray[0], 0.04)};
          color: ${theme.palette.gray[4]};
        }
      }
    }

    .subtitle {
      color: ${theme.colorTextTertiary};
    }
  `
);
